import React from 'react';

import ButtonLink from '@/components/common/ButtonLink/ButtonLink';
import { FormattingUtils } from '@/utils/Formatting.utils';
import styles from './custom-toggle.module.scss';

interface IDaysCountProps {
  days: number;
  onEditDays: () => void;
}

export default function DaysCount({
  days,
  onEditDays
}: IDaysCountProps) {
  return (
    <div className={styles['ag-before-renewal__days-count']}>
      (<b>{days}</b> {FormattingUtils.pluralize(days, 'day')})
      {' - '}
      <ButtonLink
        style={{ marginLeft: 5 }}
        onClick={onEditDays}
      >
        <div className={styles['days-edit-btn']}>
          Edit
        </div>
      </ButtonLink>
    </div>
  );
}
